import {
  getCentroidCoordinatesByFieldUuid
} from 'boundaries/selectors';
import {
  getActiveFieldUuid,
  getActiveUserId
} from 'current/selectors';
import {
  getSeasonByDateAndSeasonActivityTypeAndCropId
} from 'seasons/selectors';


import {
  fetchSeasonForDate
} from 'seasons/loaders';
import {
  processSeason
} from 'seasons/processors';


export const findSeasonCodeByDateAndSeasonActivityType = ({
  dispatch, seasonActivityType, cropId, date, getState
}) => {
  return Promise.resolve() // force a thenable wrapper
  .then( () => {
    const state = getState();

    const season = getSeasonByDateAndSeasonActivityTypeAndCropId({ state, date, seasonActivityType, cropId });
    if (season) {
      return Promise.resolve(season.season);
    }

    const userId = getActiveUserId(state);
    const fieldUuid = getActiveFieldUuid(state);
    const centroidCoordinates = getCentroidCoordinatesByFieldUuid(state, fieldUuid);

    return fetchSeasonForDate({ centroidCoordinates, cropId, date, seasonActivityType, userId })
    .then((rawSeason) => processSeason({ dispatch, rawSeason, seasonActivityType, cropId }))
    .then((season) => season.season);
  });
};
